import "core-js";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './assets/fonts/LGSmartBold__W.eot';
import './assets/fonts/LGSmartBold__W.svg';
import './assets/fonts/LGSmartBold__W.ttf';
import './assets/fonts/LGSmartBold__W.woff';
import './assets/fonts/LGSmartBold__W.woff2';

import './assets/fonts/LGSmartRegular__W.eot';
import './assets/fonts/LGSmartRegular__W.svg';
import './assets/fonts/LGSmartRegular__W.ttf';
import './assets/fonts/LGSmartRegular__W.woff';
import './assets/fonts/LGSmartRegular__W.woff2';

import './assets/fonts/LGSmartLight__W.eot';
import './assets/fonts/LGSmartLight__W.svg';
import './assets/fonts/LGSmartLight__W.ttf';
import './assets/fonts/LGSmartLight__W.woff';
import './assets/fonts/LGSmartLight__W.woff2';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
